import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import "react-datepicker/dist/react-datepicker.css";
import './AdminDashboard.css';
import Dashboard from './Dashboard.js';
import DotLoader from '../components/DotLoader.js'
import LineChartParachute from '../components/LineChartParachute.js'
import BarChartParachute from '../components/BarChartParachute.js'
import AreaChartParachute from '../components/AreaChartParachute.js'

const AdminDashboard = () => {

  const [isLoading, setIsLoading] = useState(true);

  const [load, setLoad] = useState({
    "top_level": false,
    "job_over_time": false,
    "user_logins_over_time": false,
    "most_view_jobs": false,
    "most_view_companies": false,
    "job_application": false,
    "user_type": false,
    "job_category": false,
    "application_status": false,
    "kpi": false,
  });
  const [error, setError] = useState("");

  const [isMostViewJob, setIsMostViewJob] = useState(true);
  const [isMostViewCompany, setIsMostViewCompany] = useState(true);


  const getStartDate = () => {
    var today = new Date();
    return new Date(new Date().setMonth(today.getMonth() - 3));
  };
  
  const getEndDate = () => {
    var today = new Date();
    return new Date(new Date().setMonth(today.getMonth() + 1));
  };

  // Platform overview data
  const [platformData, setPlatformData] = useState({
    total_users: 12547,
    total_companies: 1834,
    total_jobs_posted: 8932,
    active_jobs: 3421,
    total_applications: 45678
  });

  const [kpiData, setKPIData] = useState({
    avg_application_per_job: 12547,
    jobs_per_company: 1834,
    active_job_rate: 8932,
    active_jobs: 3421,
    candidate_to_company_ratio: 45678
  });

  // Jobs posted over time
  const [jobsOverTimeData, setJobsOverTimeData] = useState([]);

  // User logins over time
  const [userLoginsData, setUserLoginsData] = useState([]);

  const [jobApplicationData, setJobApplicationData] = useState([]);

  // Top companies by job posts
  const [topCompaniesData, setTopCompaniesData] = useState([
    { company: 'TechCorp Inc', jobs: 156 },
    { company: 'InnovateLabs', jobs: 134 },
    { company: 'DataSolutions', jobs: 98 },
    { company: 'CloudTech', jobs: 87 },
    { company: 'StartupXYZ', jobs: 72 }
  ]);

  const [topViewJob, setTopViewJobData] = useState([]);
  const [topViewCompany, setTopViewCompanyData] = useState([]);

  // User type breakdown
  const [userTypeData, setUserTypeData] = useState([
    { name: 'Candidates', value: 9638, percentage: 76.8 },
    { name: 'Company Users', value: 2909, percentage: 23.2 }
  ]);

  // Job category breakdown
  const [jobCategoryData, setJobCategoryData] = useState([
  ]);

  // Application status breakdown
  const [applicationStatusData, setApplicationStatusData] = useState([]);

  const [startDate, setStartDate] = useState(getStartDate());
  const [endDate, setEndDate] = useState(getEndDate());
  const [userData, setUserData] = useState({
    name: "Admin User",
    email: "admin@platform.com"
  });

  const formatDate = (date) => {
    if (date === null) return "";
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).replace(',', '');
  };

  const formatDateAPI = (date) => {
    return date.toISOString().substring(0, 10);
  }

  const getDatesParam = () => {
    return new URLSearchParams({
      start: formatDateAPI(startDate),
      end: formatDateAPI(endDate),
    }).toString();
  }

  const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7c7c', '#8dd1e1', '#d084d0', '#87d068'];

  const loadingTopLevel = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError('Authentication token not found');
        setLoad({...isLoading, top_level: true});
        return;
      }      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/top-level?${getDatesParam()}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setPlatformData({ 
          total_users: data.total_users,
          total_companies: data.total_company,
          total_jobs_posted: data.jobs_posted,
          active_jobs: data.active_jobs,
          total_applications: data.total_application
        });
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        top_level: false
      });
    }
  };

    const jobsOverTime = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Authentication token not found');
        setLoad({...isLoading, job_over_time: true});
        return;
      }      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/jobs-posting-overtime?${getDatesParam()}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setJobsOverTimeData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        job_over_time: false
      });
    }
  };

  const userLoginOvertime = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Authentication token not found');
        setLoad({...isLoading, user_logins_over_time: true});
        return;
      }      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/user-login-overtime?${getDatesParam()}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserLoginsData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        user_logins_over_time: false
      });
    }
  };

  const mostJobViewing = async () => {
    try {     
      const token = localStorage.getItem('token');
      setLoad({...isLoading, most_view_jobs: true});

      const param = new URLSearchParams({
        start: formatDateAPI(startDate),
        end: formatDateAPI(endDate),
        dynamic_type: isMostViewJob ? "view" : "application",
      }).toString();

      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/jobs-viewing?${param}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setTopViewJobData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        most_view_jobs: false
      });
    }
  };

  const mostCompanyViewing = async () => {
    try {     
      const token = localStorage.getItem('token');
      setLoad({...isLoading, most_view_companies: true});

      const param = new URLSearchParams({
        start: formatDateAPI(startDate),
        end: formatDateAPI(endDate),
        dynamic_type: isMostViewCompany ? "view" : "application",
      }).toString();

      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/company-viewing?${param}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setTopViewCompanyData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        most_view_companies: false
      });
    }
  };

  const jobCategoryBreakdown = async () => {
    try {     
      const token = localStorage.getItem('token');
      setLoad({...isLoading, job_category: true});

      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/job-category-breakdown?${getDatesParam()}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setJobCategoryData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        job_category: false
      });
    }
  };

  const applicationStatusBreakdown = async () => {
    try {     
      const token = localStorage.getItem('token');
      setLoad({...isLoading, application_status: true});

      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/application-status-breakdown?${getDatesParam()}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setApplicationStatusData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        application_status: false
      });
    }
  };

  const topKPI = async () => {
    try {     
      const token = localStorage.getItem('token');
      setLoad({...isLoading, kpi: true});

      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/top-kpi?${getDatesParam()}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setKPIData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        kpi: false
      });
    }
  };

  const jobApplicationOverTime = async () => {
    try {     
      const token = localStorage.getItem('token');
      setLoad({...isLoading, job_application: true});

      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_analytics/job-application-overtime?${getDatesParam()}`, {
        headers: {'Authorization': `Bearer ${token}`}
      });
      
      if (response.ok) {
        const data = await response.json();
        setJobApplicationData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to fetch JSON data');
      }
    } catch (error) {
      setError('Failed to fetch JSON data');
      console.error('Error fetching JSON data:', error);
    } finally {
      setLoad({
        ...isLoading,
        job_application: false
      });
    }
  };

  useEffect(() => {
      loadingTopLevel();
      jobsOverTime();
      userLoginOvertime();
      jobCategoryBreakdown();
      applicationStatusBreakdown();
      topKPI();
      jobApplicationOverTime();
  }, [startDate, endDate]);

    useEffect(() => {
      mostJobViewing();
  }, [startDate, endDate, isMostViewJob]);

  useEffect(() => {
      mostCompanyViewing();
  }, [startDate, endDate, isMostViewCompany]);


  return (
  <Dashboard page={"home"}>
    <div className="admin-dashboard">
      <div className="dashboard-container">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-content">
            <h1>Platform Dashboard</h1>
            <p>Analytics overview from {formatDate(startDate)} to {formatDate(endDate)}</p>
          </div>
          <div className="date-picker">
            <DatePicker
              selectsRange
              startDate={startDate}
              endDate={endDate}
              onChange={dates => {
                const [start, end] = dates;
                setStartDate(start);
                setEndDate(end);
              }}
              className="custom-datepicker"
            />
          </div>
        </div>

        {/* Overview Cards */}
        <div className="overview-cards">
          <div className="overview-card users">
            <h2>{platformData.total_users.toLocaleString()}</h2>
            <p>Total Users</p>
          </div>
          <div className="overview-card companies">
            <h2>{platformData.total_companies.toLocaleString()}</h2>
            <p>Total Companies</p>
          </div>
          <div className="overview-card jobs">
            <h2>{platformData.total_jobs_posted.toLocaleString()}</h2>
            <p>Jobs Posted</p>
          </div>
          <div className="overview-card active-jobs">
            <h2>{platformData.active_jobs.toLocaleString()}</h2>
            <p>Active Jobs</p>
          </div>
          <div className="overview-card applications">
            <h2>{platformData.total_applications.toLocaleString()}</h2>
            <p>Total Applications</p>
          </div>
        </div>

        {/* Charts Grid */}
        <div className="charts-grid">
          {/* Jobs Posted Over Time */}
          <div className="chart-container">
            <h3>Jobs Posted Over Time</h3>
            {load.job_over_time ? <DotLoader /> : 
              <AreaChartParachute data={jobsOverTimeData} xLabel="date" yLabel="posting" />
           }
          </div>

          {/* User Logins Over Time */}
          <div className="chart-container">
            <h3>User Logins Over Time</h3>
            {load.user_logins_over_time ? <DotLoader /> : 
              <BarChartParachute data={userLoginsData} xLabel="date" yLabel="posting" yDisplay="Logins" />
            }
          </div>
        </div>

        {/* Top Companies and User Types */}
        <div className="secondary-grid">
          {/* Top Companies */}
          <div className="breakdown-container">
            <h3>Most View Jobs
              <button 
                onClick={ () => {setIsMostViewJob(!isMostViewJob)} }
                className='view-toggle-btn active'>{isMostViewJob ? "Top Applied" : "Top Viewed"}</button>
            </h3>
            <div className="breakdown-list">

            {load.most_view_jobs ? <DotLoader /> : 
              <>
                {topViewJob.map((category, index) => (
                  <div key={category.job_id + index} className="breakdown-item">
                    <div 
                      className="breakdown-color"
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    ></div>
                    <div className="breakdown-content">
                      <span className="breakdown-name">{category.title}</span>
                      <span className="breakdown-stats">{category.viewing.toLocaleString()} ({category.percentage}%)</span>
                    </div>
                  </div>
                ))}
              </>
            }
            </div>
          </div>

          {/* User Type Breakdown */}
          <div className="breakdown-container">
            <h3>Most View Companies 
                <button 
                  onClick={ () => {setIsMostViewCompany(!isMostViewCompany)} }
                className='view-toggle-btn active'>{isMostViewCompany ? "Top Applied" : "Top Viewed"}</button> </h3>
            <div className="breakdown-list">
              {load.most_view_companies ? <DotLoader /> : 
              <>
                {topViewCompany.map((category, index) => (
                  <div key={category.company_id} className="breakdown-item">
                    <div 
                      className="breakdown-color"
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    ></div>
                    <div className="breakdown-content">
                      <span className="breakdown-name">{category.name}</span>
                      <span className="breakdown-stats">{category.viewing.toLocaleString()} ({category.percentage}%)</span>
                    </div>
                  </div>
                ))}
              </>
              }
            </div>
          </div>
        </div>

        <div className="kpi-container">
          <h3>Key Performance Indicators</h3>
          <div className="kpi-grid">
            <div className="kpi-card">
              <h4>Avg Applications per Job</h4>
              <p>{Math.round(kpiData.avg_application_per_job)}</p>
            </div>
            <div className="kpi-card">
              <h4>Jobs per Company</h4>
              <p>{Math.round( kpiData.jobs_per_company)}</p>
            </div>
            <div className="kpi-card">
              <h4>Active Job Rate</h4>
              <p>{Math.round((kpiData.active_job_rate))}%</p>
            </div>
            <div className="kpi-card">
              <h4>Candidate to Company Ratio</h4>
              <p>{kpiData.candidate_to_company_ratio}</p>
            </div>
          </div>
        </div>

        <div className="secondary-grid">
          {/* Top Companies */}
          {/* User Type Breakdown */}
          <div className="chart-container">
            <h3>Application OverTime</h3>
            {load.job_application ? <DotLoader /> : 
              <LineChartParachute data={jobApplicationData} xLabel="date" yLabel="posting" yDisplay="Job Application" />
           }
          </div>
        </div>

        {/* Job Categories and Application Status */}
        <div className="secondary-grid">
          {/* Job Categories */}
          <div className="breakdown-container">
            <h3>Job Categories Breakdown</h3>
            <div className="breakdown-list">
            
            {load.job_category ? <DotLoader /> : 
              <>
                {jobCategoryData.map((category, index) => (
                  <div key={category.name} className="breakdown-item">
                    <div 
                      className="breakdown-color"
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    ></div>
                    <div className="breakdown-content">
                      <span className="breakdown-name">{category.name}</span>
                      <span className="breakdown-stats">{category.count.toLocaleString()} ({category.percentage}%)</span>
                    </div>
                  </div>
                ))}
              </>
            }
            </div>
          </div>

          {/* Application Status */}
          <div className="chart-container">
            <h3>Application Status Breakdown</h3>
            {load.application_status ? <DotLoader /> : 
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={applicationStatusData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ name, percentage }) => `${name}: ${percentage}%`}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="count"
                    >
                      {applicationStatusData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
            }
          </div>
        </div>

        {/* Additional Metrics */}


      </div>
    </div>
  </Dashboard>
  );
};

export default AdminDashboard;